import {
  Account,
  PammTauroMarketsAccount,
  PammTauroMarketsMauritiusAccount,
  PammTauroMarketsMt5Account,
} from '../../../../../graphql/types'
import {getMetadataFromAccount} from '../../../AccountCard/utils'

export type PammInvestorAccount =
  | PammTauroMarketsAccount
  | PammTauroMarketsMauritiusAccount
  | PammTauroMarketsMt5Account

export type PammInvestorCardState = {
  linkedForexAccount: Account | null
  linkedMtBalance: number
  isDepositNeeded: boolean
  isTransferNeeded: boolean
  isUnapproved: boolean
}

export function getPammInvestorCardState(
  account: PammInvestorAccount,
  restAccounts: Account[],
): PammInvestorCardState {
  const accountMetadata = getMetadataFromAccount(account)
  const relatedForexAccountId = accountMetadata.relatedForexAccountId as number | undefined
  const linkedForexAccount = relatedForexAccountId
    ? restAccounts.find(({id}) => id === relatedForexAccountId) ?? null
    : null
  const linkedMtBalance = linkedForexAccount?.balance ?? 0
  const minimumDeposit = account.minimumDeposit ?? 0

  const isDepositNeeded = Boolean(account.unconnected && linkedMtBalance < minimumDeposit)
  const isTransferNeeded = Boolean(account.unconnected && linkedMtBalance >= minimumDeposit)
  const isUnapproved = Boolean(
    !account.unconnected && !account.isPammInvestorAccountApprovedByMoneyManager,
  )

  return {
    linkedForexAccount,
    linkedMtBalance,
    isDepositNeeded,
    isTransferNeeded,
    isUnapproved,
  }
}
